export const Role = {
  Administrator: "Administrator",
  Editor: "Editor",
  Moderator: "Moderator / Reviewer",
  Viewer: "Viewer",
};
